export enum AffiliateStatus {
  ACTIVE = 'ACTIVE',
  BLOCK = 'BLOCK',
  UNBLOCK = 'UNBLOCK',
  VERIFY = 'VERIFY',
  PENDING = 'PENDING',
  UNVERIFIED = 'UNVERIFIED',
}

export enum AffiliateStatusText {
  ACTIVE = 'Active',
  BLOCK = 'Blocked',
  PENDING = 'Pending',
  UNVERIFIED = 'Unverified',
  UNBLOCK = 'Unblock',
  VERIFY = 'Verify',
}

export enum AffiliatePageType {
  VERIFIED = 'VERIFIED',
  PENDING = 'PENDING',
}

export enum PostbackActionTypeEnum {
  REGISTRATION = 'REGISTRATION',
  DEPOSIT = 'DEPOSIT',
}
